import {css} from '@emotion/react';
import {Avatar, useTheme} from '@mui/material';
import SvgIcon from '@mui/material/SvgIcon';
import {getIconComponentByName, GetStylesFunction, LightLoadingSpinner, LoadingSpinner} from '@wallaby-ui/core';
import classNames from 'classnames';
import * as React from 'react';

interface OwnProps {
  iconName?: string;
  iconClass?: string;
  iconViewbox?: string;
  avatarText?: string;
  isPatient?: boolean;
  navigationMenuOpen?: boolean;
  isDynamic?: boolean;
  isActive?: boolean;
}

type Props = OwnProps;

export const NavigationItemIcon: React.FC<Props> = (props) => {
  const {iconName, iconClass, iconViewbox = '0 0 12 12', avatarText, isPatient, navigationMenuOpen, isDynamic, isActive} = props;
  const theme = useTheme();

  const styles = getStyles({
    theme,
    params: {isDynamic, navigationMenuOpen, isActive},
  });

  const stringAvatar = (name: string, isPatient) => {
    return (
      isPatient && {
        children: `${name?.split?.(' ')?.[0]?.[0]}${name?.split?.(' ')?.[1]?.[0]}`,
      }
    );
  };

  let RenderedIconComponent;
  let renderedIcon = iconClass && <i className={classNames(iconClass, 'fa-fw')} />;
  if (iconName) {
    RenderedIconComponent = getIconComponentByName(iconName);
  }
  if (isPatient && avatarText) {
    renderedIcon = <Avatar data-name={'navigation-item-icon--avatar'} {...stringAvatar(avatarText, isPatient)} css={styles.avatar} />;
  }
  if (isPatient && !avatarText) {
    renderedIcon = <LightLoadingSpinner loading size={24} marginTop={0} />;
  }

  return (
    <div data-name={'navigation-item-icon--icon-wrapper'} css={styles.itemIconWrapper}>
      {RenderedIconComponent ? (
        <SvgIcon data-name={'navigation-item-icon--icon'} component={RenderedIconComponent} css={styles.itemIcon} viewBox={iconViewbox} />
      ) : (
        renderedIcon
      )}
    </div>
  );
};

NavigationItemIcon.displayName = 'NavigationItemIcon';

const getStyles: GetStylesFunction = (options) => {
  // avatar colors are in NavigationItem.less
  return {
    itemIconWrapper: css`
      width: 24px;
      height: 24px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      margin-right: ${options?.params?.navigationMenuOpen && options?.params?.isDynamic ? '2px' : '0px'};
      flex-shrink: 0;
    `,
    itemIcon: css`
      max-width: 12px;
      max-height: 12px;
    `,
    avatar: css`
      width: 24px;
      height: 24px;
      font-family: var(--dlFontFamilyBold);
      font-size: 11px;
    `,
  };
};
